export default "__VITE_ASSET__sdY6aAfb__"